// extracted by mini-css-extract-plugin
export default {"container":"AIAssistantPage_container__T8izf","header":"AIAssistantPage_header__+9Vax"};